var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "edit_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M61.078 23.25 25.328 59H5V38.672l35.75-35.75zM9 40.328V55h14.672l24.25-24.25L33.25 16.078zM36.078 13.25 50.75 27.922l4.672-4.672L40.75 8.578z"
  })));
};
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNjEuMDc4MSAyMy4yNUwyNS4zMjgxIDU5SDVWMzguNjcxOUw0MC43NSAyLjkyMTg4TDYxLjA3ODEgMjMuMjVaTTkgNDAuMzI4MVY1NUgyMy42NzE5TDQ3LjkyMTkgMzAuNzVMMzMuMjUgMTYuMDc4MUw5IDQwLjMyODFaTTM2LjA3ODEgMTMuMjVMNTAuNzUgMjcuOTIxOUw1NS40MjE5IDIzLjI1TDQwLjc1IDguNTc4MTJMMzYuMDc4MSAxMy4yNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";